import {ButtonHTMLAttributes, ReactElement, useState} from "react";
import {Overlay} from "@/widgets/Overlay";
import {ModalBody, ModalHeader} from "@/widgets/ModalParts";
import {Button} from "@/components/buttons/Button";
import DOMPurify from "dompurify";
import {useCopyToClipboard} from "@/hooks/useCopyToClipboard";
import {FaRegCopy} from "react-icons/fa";
import Toast from "@/components/Toast";

interface Props {
    description?: string;
    couponCode: string;
    isOpen: boolean;
    toggle: () => void;
}

function PromoTokenCouponCodeModal(props: Props): ReactElement {
    const {copyToClipboard} = useCopyToClipboard();
    const [isCopied, setIsCopied] = useState<boolean>(false);

    return (
        <>
            <Toast
                variant="info"
                message='Copied!'
                isOpen={isCopied}
                showButton={false}
                onDismiss={() => setIsCopied(false)}
                duration={3000}
            />
            <Overlay
                isOpen={props.isOpen}
                toggle={props.toggle}
                contentClassName="promo-token-coupon-code-modal"
                size="sm"
            >
                <ModalHeader
                    title="Claim Reward"
                    toggle={props.toggle}
                />

                <ModalBody>

                    {props.description &&
												<div
												    className="promo-token-coupon-code-modal_description"
												    // eslint-disable-next-line react/no-danger
												    dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(props.description)}}
												/>
                    }

                    <input
                        className="promo-token-coupon-code-modal_input"
                        readOnly={true}
                        value={props.couponCode}
                    />

                    <div className="promo-token-coupon-code-modal_actions">
                        <Button variant="primary"
                            onClick={() => {
                                setIsCopied(true);
                                copyToClipboard(props.couponCode);
                            }}
                            leftIcon={FaRegCopy}
                        >
                            Copy to clipboard
                        </Button>

                    </div>
                </ModalBody>
            </Overlay>
        </>
    );
}

export default PromoTokenCouponCodeModal;
